import {ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {BasePageComponent} from "@core-components/page-content/base-page.component";
import {ConsoleContextService} from "@security/console-context.service";
import {PanelType} from "@shared-components/info-panel/info-panel.component";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {UtilsService} from "@shared-services/utils.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {equalsIgnoreCase} from "@ui-kit/framework/util/static/string-util";
import {cloneDeep} from "lodash";
import {Survey, SurveyStatus} from "../../surveys.model";
import {SurveyDetailsComponent} from "./survey-details/survey-details.component";
import {
  SurveyFormBuilderConfigureSmartFormComponent
} from "./survey-form-builder-configure-smart-form/survey-form-builder-configure-smart-form.component";
import {
  SurveyFormBuilderQuestionsComponent
} from "./survey-form-builder-questions/survey-form-builder-questions.component";

@Component({
  selector: 'app-survey-form-builder',
  templateUrl: './survey-form-builder.component.html',
  styleUrl: './survey-form-builder.component.scss'
})
export class SurveyFormBuilderComponent extends BasePageComponent implements OnInit {
  protected readonly SurveyStatus = SurveyStatus;
  protected readonly equalsIgnoreCase = equalsIgnoreCase;


  /*
  this component will switch between the questions tab and the smart config tabs, have child components for each
    of the tabs


   */

  /* todo - methods required for component
       -     show missing email question - checks if the form is set to allow single submission only and payload contains a question of the top level called email. if it does not, return true
         - message: "This form requires a mandatory email question to allow only single submission", have button to add email question in onfo panel
       -     add required email question - if show missing email question = true, then add a question to the top level, called email since the form requires email to allow only single submission
       -     add contact info questions - add email, phone number, first name, last name to the top level of the form
       - if there are questions, smart config tab can be enabled
       - on details tab, need to impl the qr code sidenav with form to get/update qr code destination and mode
       - preview form - need to add route and hook up button

     todo - remove the view childs of the child components. move the initiatiors to behavior subjects in the
             formbuilder service or the service for each of the child components. then subscribe to them in the child
             component to action the buttons so its cleaner




  */


  @Input() survey!: Survey;
  @Output() updatedSurvey: EventEmitter<Survey> = new EventEmitter<Survey>();

  @ViewChild('appSurveyFormBuilderQuestions') questionsComponent!: SurveyFormBuilderQuestionsComponent;
  @ViewChild('appSurveyDetails') appSurveyDetails!: SurveyDetailsComponent;
  @ViewChild('appSurveyFormBuilderConfigureSmartForm') surveyFormBuilderConfigureSmartForm!: SurveyFormBuilderConfigureSmartFormComponent;

  protected loading$ = this.loader.loading$;
  protected selectedTabIndex: number = 0;
  protected pendingChanges: boolean = false;
  protected initialSurvey: Survey;

  protected selectedTab: "details" | "questions" | "smart-form" = "details";

  constructor(injector: Injector,
              public utils: UtilsService,
              public dateUtils: DateUtilsService,
              private context: ConsoleContextService,
              public loader: LoadingService,
              private router: Router,
              private changeDetectorRefs: ChangeDetectorRef) {
    super(injector);

    // console.log("SurveyFormBuilderComponent.constructor", this.survey);
    this.initialSurvey = cloneDeep(this.survey);

    //todo may not need this
    // if(!this.survey.payload){
    //   this.survey.payload = [];
    // }
    // console.log('this.context.getCurrentLocationOffering(this.offering?.offeringUuid!)', this.context.getCurrentLocationOffering(this.offering?.uuid!));
  }

  get pageLabel(): string {
    switch (this.selectedTab) {
      case "questions":
        return "Survey Questions";
      case "smart-form":
        return "Smart Form Configuration";
      default:
        return "Survey Details";
    }
  }

  ngOnInit(): void {
    this.initialSurvey = cloneDeep(this.survey);
  }

  switchTabs(selectedTab: any) {
    if (this.selectedTab === selectedTab) {
      return;
    }
    this.selectedTab = selectedTab;
  }

  canNavigate(tab: any) {
    return this.selectedTab === tab ?
      true :
      this.selectedTab !== tab && !this.pendingChanges;
  }

  formTemplateChanges(form: Survey) {
    this.survey = form;
    this.initialSurvey = cloneDeep(this.survey);
    this.updatedSurvey.emit(form);
  }

  onCancelChanges() {
    this.survey = cloneDeep(this.initialSurvey);
    this.pendingChanges = false;
    this.changeDetectorRefs.detectChanges();
  }

  onSaveQuestions() {
    this.questionsComponent.saveForm();
  }

  onSaveSmartConfig() {
    this.surveyFormBuilderConfigureSmartForm.saveForm();
  }

  publishSurvey() {
    this.appSurveyDetails.publish();
  }

  public previewForm() {
    const locationOffering = this.context.getCurrentLocation()?.locationOfferings?.find(offering => offering.offeringUuid === this.offering?.offeringUuid)!;

    const url = this.router.serializeUrl(this.router.createUrlTree([`/preview-survey/${this.survey.code}`],
      {
        queryParams: {
          locationCode: locationOffering.locationCode!,
          offeringCode: locationOffering.offeringCode!,
          embedKey: locationOffering.embedKey!
        }
      }));
    window.open(url, '_blank');
  }

  protected readonly PanelType = PanelType;
}
